import { toPlatePlugin } from '@udecode/plate/react';

import { BaseSuperscriptPlugin } from '../lib/BaseSuperscriptPlugin';

export const SuperscriptPlugin = toPlatePlugin(BaseSuperscriptPlugin);
